export default __webpack_public_path__ + "static/media/vespa-admin-ui.eeca8ce8.png";